import { Users as UsersIcon } from 'lucide-react';
import { usePersonaCohort } from './hooks/usePersonaCohort';
import { PersonaCohortTable } from './components/PersonaCohortTable';
import { CohortLookbackToggle } from './components/CohortLookbackToggle';

export function PersonaCohortView() {
  const { data, loading } = usePersonaCohort();

  return (
    <div className="space-y-5">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <UsersIcon size={20} className="text-indigo-500" />
          <div>
            <div className="text-[10px] font-mono uppercase text-slate-400">
              Performance
            </div>
            <h1 className="text-lg font-bold text-navy-900">Personas</h1>
          </div>
        </div>
        <p className="text-xs text-slate-500 max-w-md text-right">
          Overview of your customer personas and their performance metrics.
        </p>
      </header>

      <div className="rounded-xl border border-slate-200 bg-white p-3">
        <CohortLookbackToggle />
      </div>

      <PersonaCohortTable rows={data?.rows ?? []} loading={loading} />
    </div>
  );
}

export default PersonaCohortView;
